import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t mt-24"
      style={{ borderColor: "var(--gf-border)", background: "var(--gf-bg-soft)" }}
    >
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="font-display text-2xl" style={{ color: "var(--gf-text)" }}>
            Book<span style={{ color: "var(--gf-accent)" }}>Freely</span>
          </div>
          <p className="text-sm mt-3 max-w-xs italic" style={{ color: "var(--gf-text-soft)" }}>
            Book It Freely.
          </p>
        </div>
        <div className="text-sm">
          <div className="uppercase tracking-[0.2em] text-xs mb-3" style={{ color: "var(--gf-text-muted)" }}>Platform</div>
          <ul className="space-y-2" style={{ color: "var(--gf-text-soft)" }}>
            <li><Link to="/services" className="hover:opacity-80">Browse services</Link></li>
            <li><Link to="/about" data-testid="footer-about-link" className="hover:opacity-80">About BookFreely</Link></li>
            <li><Link to="/help" data-testid="footer-help-link" className="hover:opacity-80">Help &amp; FAQ</Link></li>
            <li><Link to="/signup?role=business" className="hover:opacity-80">List your business</Link></li>
            <li><Link to="/terms" className="hover:opacity-80">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:opacity-80">Privacy Policy</Link></li>
            <li>
              <button
                type="button"
                data-testid="footer-cookie-prefs-btn"
                onClick={() => window.dispatchEvent(new CustomEvent("bf-open-cookie-prefs"))}
                className="hover:opacity-80 text-left"
                style={{ background: "none", padding: 0, color: "inherit" }}
              >
                Cookie preferences
              </button>
            </li>
          </ul>
        </div>
        <div className="text-sm">
          <div className="uppercase tracking-[0.2em] text-xs mb-3" style={{ color: "var(--gf-text-muted)" }}>For businesses</div>
          <ul className="space-y-2" style={{ color: "var(--gf-text-soft)" }}>
            <li><Link to="/signup?role=business" className="hover:opacity-80">List your business</Link></li>
            <li><Link to="/signup?role=business" className="hover:opacity-80">See pricing</Link></li>
            <li>Built-in calendar &amp; email reminders</li>
            <li>
              <a href="mailto:bookfreely.support@gmail.com" className="hover:opacity-80" data-testid="footer-support-email">
                bookfreely.support@gmail.com
              </a>
            </li>
          </ul>
          <div className="uppercase tracking-[0.2em] text-xs mt-6 mb-3" style={{ color: "var(--gf-text-muted)" }}>Follow us</div>
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/bookfreely?igsh=MTRqb2RzOGV3aW55bA%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BookFreely on Instagram"
              data-testid="footer-instagram-link"
              className="hover:opacity-80 inline-flex items-center gap-1.5"
              style={{ color: "var(--gf-text-soft)" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
              <span>Instagram</span>
            </a>
            <a
              href="https://www.tiktok.com/@bookfreely_official"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BookFreely on TikTok"
              data-testid="footer-tiktok-link"
              className="hover:opacity-80 inline-flex items-center gap-1.5"
              style={{ color: "var(--gf-text-soft)" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.66A8.16 8.16 0 0 0 21.62 10V6.56a4.83 4.83 0 0 1-2.03.13z"/>
              </svg>
              <span>TikTok</span>
            </a>
          </div>
        </div>
      </div>
      <div className="border-t py-5 text-center text-xs" style={{ borderColor: "var(--gf-border)", color: "var(--gf-text-muted)" }}>
        © {new Date().getFullYear()} BookFreely. All rights reserved.
      </div>
    </footer>
  );
}
